module.exports = "<div class=\"item item-input item-stacked-label item--login\">\r\n    <span class=\"input-label\">{{'PASSWORD' | translate}}</span>\r\n    <input type=\"text\" class=\"password-input\" ng-if=\"$ctrl.showPassword\" ng-model=\"$ctrl.model\" required>\r\n    <input type=\"password\" class=\"password-input\" ng-if=\"!$ctrl.showPassword\" ng-model=\"$ctrl.model\" required>\r\n    <i class=\"button button-clear show-password-button ion-eye\" ng-class=\"{'show-password-active': $ctrl.showPassword}\" ng-click=\"$ctrl.showPassword = !$ctrl.showPassword;\"></i>\r\n</div>\r\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/directives/common/showPasswordElement.html
 ** module id = 439
 ** module chunks = 0
 **/